module.exports = __webpack_public_path__ + "static/media/Mulish-Regular.37d94614.svg";